/**
 * @generated SignedSource<<720994cfbe15d19dab8a9d857e0e556b>>
 * @relayHash 4858d275861133a3e4dd3b7182848b73
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0f1fe429f54600d63a7da73ece7a06984f20a4e04ceabb99a56ccc7b7e356f5d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HeaderControlPanelContentQuery } from './HeaderControlPanelContentQuery.graphql';

const node: PreloadableConcreteRequest<HeaderControlPanelContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0f1fe429f54600d63a7da73ece7a06984f20a4e04ceabb99a56ccc7b7e356f5d",
    "metadata": {},
    "name": "HeaderControlPanelContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
